// localStorage wishlist: paints [data-wishlist][data-handle] hearts, keeps
// [data-wishlist-count] badges in sync, and exposes a small API + change event
// so the drawer and page can re-render without re-implementing storage.
(() => {
  const KEY = "jg-wishlist";
  const load = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };
  const save = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} };

  const paint = () => {
    const list = load();
    const set = new Set(list);
    document.querySelectorAll("[data-wishlist]").forEach((b) =>
      b.classList.toggle("is-wishlisted", set.has(b.dataset.handle))
    );
    document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };

  const announce = (list) => {
    paint();
    document.dispatchEvent(new CustomEvent("wishlist:change", { detail: { handles: list } }));
  };

  window.theme = window.theme || {};
  window.theme.getWishlist = load;
  // Exposed because paint() only ran at script time and on a click, so hearts on cards
  // that arrive LATER were never filled in — on the wishlist page, where every card is
  // saved, that meant none of them looked selected. theme.renderProductCards calls this
  // after appending, which also covers Recently viewed and recommendations.
  window.theme.paintWishlist = paint;
  window.theme.removeFromWishlist = (handle) => {
    const list = load().filter((h) => h !== handle);
    save(list);
    announce(list);
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist]");
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.handle;
    let list = load();
    const added = !list.includes(handle); // computed before mutation
    list = added ? [handle, ...list] : list.filter((h) => h !== handle); // newest first
    save(list);
    announce(list);
    const st = window.theme.strings || {};
    window.theme.toast(added ? st.wishlistAdded : st.wishlistRemoved, { type: added ? "success" : "info" });
  });

  paint(); // defer scripts run after DOM parse
  document.addEventListener("shopify:section:load", paint); // theme editor re-renders
})();
